<template>
  <!-- 用户流水控制 -->
  <div v-if="$route.query.pv" class="task-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openAddDialog">添加控制</el-button>
        </el-form-item>
        <el-form-item label="多选开关：" style="margin-left: 20px">
          <el-switch
            v-model="all_status"
            :active-value="2"
            :inactive-value="1"
            active-text="打开"
            inactive-text="关闭"
            @change="changeSwitch"
          >
          </el-switch>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" size="small" @click="openOtherSelectBox()"
            >不受限盒子</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="ID" align="center"> </el-table-column>
        <el-table-column prop="name" label="限制名称" align="center">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status === 2">开</el-tag>
            <el-tag type="danger" v-if="row.status === 1">关</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="300px">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="openEditDialog(row)"
              >编辑</el-button
            >
            <el-button type="primary" size="small" @click="openAddUser(row)"
              >添加用户</el-button
            >
            <el-button type="primary" size="small" @click="openSelectBox(row)"
              >盒子排除</el-button
            >
            <el-button
              type="success"
              size="small"
              style="margin-top: 10px"
              @click="openNewUserScope(row)"
              v-if="row.name === '新用户'"
              >新用户范围</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- 新用户充值流水控制 -->
    <WaterControllerDialog
      :visible="setControlVisible"
      v-model="dialogInfo"
      :controlType="dialogType"
      @close="setControlVisible = false"
      @refresh="getData"
    ></WaterControllerDialog>

    <!-- 添加限制用户 -->
    <UserControllerDialog
      :visible="setUserVisible"
      v-model="dialogInfo"
      @close="setUserVisible = false"
      @refresh="getData"
    ></UserControllerDialog>

    <!-- 添加限制盒子 -->
    <SelectBoxDialog
      :visible="setBoxVisible"
      v-model="dialogInfo"
      @close="setBoxVisible = false"
    ></SelectBoxDialog>

    <!-- 设置新用户范围 -->
    <NewUserScopeDialog
      :visible="setNewUserVisible"
      @close="setNewUserVisible = false"
    ></NewUserScopeDialog>

    <!-- 添加其他排除的限制盒子 -->
    <OtherSelectBoxDialog
      :visible="setOtherSelectBoxVisible"
      v-model="dialogInfo"
      @close="setOtherSelectBoxVisible = false"
    ></OtherSelectBoxDialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import WaterControllerDialog from '@/components/waterControl/WaterControllerDialog'
import UserControllerDialog from '@/components/waterControl/UserControllerDialog'
import SelectBoxDialog from '@/components/waterControl/SelectBoxDialog'
import OtherSelectBoxDialog from '@/components/waterControl/OtherSelectBoxDialog'
import NewUserScopeDialog from '@/components/waterControl/NewUserScopeDialog'

export default {
  components: {
    WaterControllerDialog,
    UserControllerDialog,
    SelectBoxDialog,
    NewUserScopeDialog,
    OtherSelectBoxDialog
  },
  data() {
    return {
      setOtherSelectBoxVisible: false,//其他盒子排除弹窗显示标志
      setNewUserVisible: false,//设置新用户范围弹窗显示标志
      setBoxVisible: false,//盒子排除弹窗显示标志
      setUserVisible: false,//添加用户弹窗显示标志
      setControlVisible: false,//新用户充值流水弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      query: {//查询条件
        page: 1,
      },
      controlArr: [],//多选框选择的数据
      all_status: 1,//控制的总开关 1是关闭 2是开启
      dataList: undefined,//列表数据
      dialogInfo: undefined,//要传递的弹窗数据
      dialogType: 1,//弹窗类型 1添加控制 2编辑控制 默认是1      
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()//获取数据列表
  },
  methods: {
    getData() {
      this.loading = true
      let params = this.query
      getApiData('water_control', params)
        .then(res => {
          this.dataList = res
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSelectionChange(val) {
      //多选行操作
      this.controlArr = []
      for (let i = 0; i < val.length; i++) {
        this.controlArr.push(val[i].id)
      }
    },
    changeSwitch(val) {
      //批量修改开关
      if (!this.controlArr || !this.controlArr.length) {
        this.$message.warning("请先选择您要处理的数据")
        this.all_status = this.all_status === 1 ? 2 : 1
        return
      }

      let params = {
        status: val,
        ids: this.controlArr
      }

      patchApiData('water_control_switch', params)
        .then(res => {
          this.$message.success("操作成功！")
          this.getData()//刷新
        }).catch((err) => {
          this.all_status = this.all_status === 1 ? 2 : 1
        })
    },
    openAddDialog() {
      //打开添加控制弹窗
      this.setControlVisible = true
      this.dialogType = 1
    },
    openEditDialog(rowInfo) {
      //打开编辑控制弹窗
      this.setControlVisible = true
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
      this.dialogType = 2
    },
    openAddUser(rowInfo) {
      //打开添加用户弹窗
      this.setUserVisible = true
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
    },
    openSelectBox(rowInfo) {
      //打开盒子排除弹窗
      this.setBoxVisible = true
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
    },
    openNewUserScope(rowInfo) {
      // 新用户范围控制
      this.setNewUserVisible = true
    },
    openOtherSelectBox() {
      //其他盒子排除
      this.setOtherSelectBoxVisible = true
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
</style>